import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { AdminTab } from '@/constants/adminTabs';

interface Props {
  propertyTabs: AdminTab[];
  businessTabs: AdminTab[];
  activeTab: string;
  onSelectTab: (key: string) => void;
}

const MobileAdminAccordion = ({
  propertyTabs,
  businessTabs,
  activeTab,
  onSelectTab,
}: Props) => {
  const renderTabButton = (tab: AdminTab) => (
    <Button
      key={tab.key}
      variant="ghost"
      className={`${
        activeTab === tab.key ? 'bg-blue-50 text-primary' : 'hover:bg-blue-50'
      } justify-start w-full gap-2 text-left`}
      onClick={() => onSelectTab(tab.key)}
    >
      {tab.icon}
      {tab.label}
    </Button>
  );

  return (
    <Accordion
      type="multiple"
      defaultValue={['property', 'business']}
      className="w-full"
    >
      <AccordionItem value="property">
        <AccordionTrigger className="text-sm font-medium hover:no-underline">
          Propiedades
        </AccordionTrigger>
        <AccordionContent className="flex flex-col gap-1">
          {propertyTabs.map(renderTabButton)}
        </AccordionContent>
      </AccordionItem>

      <AccordionItem value="business">
        <AccordionTrigger className="text-sm font-medium hover:no-underline">
          Negocio
        </AccordionTrigger>
        <AccordionContent className="flex flex-col gap-1">
          {businessTabs.map(renderTabButton)}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default MobileAdminAccordion;
